import type { QuestionRow } from '@webapp/common/entities/question-row';
import { updateItemInArray } from '@webapp/common/lib/utils';
import type { Question } from '@webapp/common/resources/entities/question';

import type { QuestionsState } from './state';

export const filterOnlyNewRows = (question: Question, rows: Array<QuestionRow>): Array<QuestionRow> => {
    const rowIds = question.rows.reduce((acc, r) => ((acc[r.id] = 1), acc), {});
    return rows.filter((r) => !rowIds[r.id]);
};

export const setQuestionFetch = ({ items }: QuestionsState, id: number, fetch: boolean): void => {
    updateItemInArray(items, id, (q: Question) => {
        q.fetch = fetch;
    });
};
